export const CARD_COLORS = Object.freeze([
  { name: 'card-purple', light: '#9c2bf6', dark: '#6110a2' },
  { name: 'card-orange', light: '#ffa26e', dark: '#de5d12' },
  { name: 'card-sky', light: '#5ecef8', dark: '#1394c3' },
  { name: 'card-mint', light: '#55e38e', dark: '#239550' },
  { name: 'card-coral', light: '#ee7878', dark: '#be2727' },
  { name: 'card-orchid', light: '#c04dca', dark: '#7a3281' },
  { name: 'card-yellow', light: '#f9d862', dark: '#c49f17' },
  { name: 'card-navy', light: '#4957d4', dark: '#2b3488' },
  { name: 'card-forest', light: '#64ab43', dark: '#57a136' },
  { name: 'card-rose', light: '#bf4965', dark: '#7b3747' }
])

export const EVENT_COLORS = Object.freeze([
  { name: 'event-peach', colorName: 'peach', light: '#ffc28d', dark: '#fdd4b5' },
  { name: 'event-yellow', colorName: 'yellow', light: '#fff59d', dark: '#ffe894' },
  { name: 'event-green', colorName: 'green', light: '#bdeea7', dark: '#bfff9e' },
  { name: 'event-teal', colorName: 'teal', light: '#b7eee4', dark: '#afffee' },
  { name: 'event-blue', colorName: 'blue', light: '#a7d4ee', dark: '#9bdcff' },
  { name: 'event-lavender', colorName: 'lavender', light: '#c1c0f4', dark: '#b0b0ff' },
  { name: 'event-pink', colorName: 'pink', light: '#ecc0f4', dark: '#f1b4ff' },
  { name: 'event-gray', colorName: 'gray', light: '#ced3d9', dark: '#b5d3ee' }
])

export const hexToRgb = (hex) => {
  return {
    red: parseInt(hex.slice(1, 3), 16),
    green: parseInt(hex.slice(3, 5), 16),
    blue: parseInt(hex.slice(5, 7), 16)
  }
}

export const hexToRgbString = (hex) => {
  const { red, green, blue } = hexToRgb(hex)
  return `rgb(${red},${green},${blue})`
}
